import {
  Alert,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import { emailTemplateFields } from "./emailAllFields";
import useStyles from "../../../components/common/model/styles";
import FormField from "../../../components/common/FormField";
import Notification from "../../../components/common/notification/Notification";
import Popup from "../../../components/common/model/Popup";
import SAVE_ICON from "../../../assets/check-mark.png";
import CLOSE_ICON from "../../../assets/closeModel.png";
import RESET_ICON from "../../../assets/trash.png";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import Validation from "../../../utils/Validation";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";
import { getCaretCharacterOffsetWithin } from "../../../utils/utils";
import {
  addEmailTemplateAction,
  getAllEventsAction,
  initialEmailTemplateLocalState,
  resetNewEmailTemplateLocal,
  setAddEmailTemplateSuccessAction,
  setNewEmailTemplateLocal,
  updateEmailTemplateAction,
} from "../../../store/reducers/emailTemplateSlice";
import { getClientForEditAction } from "../../../store/reducers/adminClientsSlice";
interface ManageEmailTemplateProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectTemplate?: any; // Adjust type as per your requirement
  setSelectedRow?: any; // Adjust type as per your requirement
  screenType?: "ADMIN" | "CLIENT"; // Add screenType prop
}

const ManageEmailTemplate = (props: ManageEmailTemplateProps) => {
  const { selectTemplate, setSelectedRow, onHide, open, title, screenType } =
    props;

  const {
    allEmailTemplates,
    allEvents,
    newEmailTemplateLocal,
    isAddEmailTemplateSuccess,leadStageWithPlaceholders
  } = useSelector((state: any) => state.emailTemplates);

  const {userProfile} = useSelector((state: any) => state.user);
 const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients
  );


  const classes = useStyles();
  const dispatch = useDispatch();
  const [isReset, setIsReset] = useState(false);

  const {
    template_name,
    subject,
    category,
    body,
    lead_stage,
    template_from,
    is_primary,
    signature_option,
    signature,
    // event,
  } = newEmailTemplateLocal?.emailTemplate || {};

  const getEditorPlainText = (value: any) => {
    if (typeof value !== "string") return value;

    return value
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
  };

  const normalizedSubject = getEditorPlainText(subject);
  const normalizedBody = getEditorPlainText(body);
  const normalizedSignature = getEditorPlainText(signature);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    template_name,
    subject: normalizedSubject,
    category,
    lead_stage,
    body: normalizedBody,
    signature_option,
    signature:
      signature_option === "custom_signature" ? normalizedSignature : "",
    // event,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [focusedField, setFocusedField] = useState<any>({
    id: "",
    cursorPosition: 0,
  });

 useEffect(() => {
    dispatch(getClientForEditAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (selectTemplate) {
      dispatch(
        setNewEmailTemplateLocal({
          emailTemplate: {
            ...newEmailTemplateLocal?.emailTemplate,
            ...selectTemplate,
          },
        }),
      );
    }
  }, [selectTemplate]);

  const senderEmailOptions = [
    userProfile?.email && {
    label: `${userProfile.email}`,
    id: userProfile.email,
  },
  editClientOriginalData?.notification_email && editClientOriginalData?.is_notification_signature_confirmed && {
    label: `${editClientOriginalData.notification_email}`,
    id: editClientOriginalData.notification_email,
  },
  editClientOriginalData?.accounts_email && editClientOriginalData?.is_account_signature_confirmed && {
    label: `${editClientOriginalData.accounts_email}`,
    id: editClientOriginalData.accounts_email,
  },
  ];


 const onChangeAction = (event: any) => {
  if (isReset) return;

  const { id, value, type, name,checked } = event.target;
  const key = type === "radio" ? name : id;

  let updatedEmailTemplate = {
    ...newEmailTemplateLocal?.emailTemplate,
    [key]: type === "checkbox" ? checked : value,
  };

  // ✅ ONLY Lead Stage Logic
  if (key === "lead_stage") {
    const selectedLeadStage = leadStageWithPlaceholders.find(
      (item: any) => item.stage === value
    );

    updatedEmailTemplate = {
      ...updatedEmailTemplate,
      placeholders: selectedLeadStage?.placeholders || [],
    };
  }

  dispatch(setNewEmailTemplateLocal({ emailTemplate: updatedEmailTemplate }));
  resetValidator(key);
};

  useEffect(() => {
    // Ensure both event and allEmailTemplates are ready

    if (
      !newEmailTemplateLocal?.emailTemplate?.event ||
      !allEmailTemplates.length
    )
      return;
    // Find the category that contains the template matching the selected event
    const selectedCategory = allEmailTemplates.find((category: any) =>
      category.templates.some(
        (template: any) =>
          template.event === newEmailTemplateLocal.emailTemplate.event,
      ),
    );
    if (selectedCategory || selectedCategory !== undefined) {
      // Find the specific template that matches the selected event
      const selectedTemplate =
        selectedCategory &&
        selectedCategory?.templates.find(
          (template: any) =>
            template.event === newEmailTemplateLocal.emailTemplate.event,
        );

      if (selectedTemplate) {
        // Construct the updated email template
        const updatedEmailTemplate = {
          ...newEmailTemplateLocal.emailTemplate,
          placeholders: Array.from(
            new Set([
              ...(newEmailTemplateLocal.emailTemplate.placeholders || []),
              // ...(selectedTemplate.placeholders || []), // Ensure placeholders exist
            ]),
          ),
          template_id: selectedTemplate?.template_id,
          template_name: selectedTemplate?.template_name || "",
          template_from: selectTemplate?.template_from,
          subject: selectedTemplate?.subject || "",
          disclaimer: selectedTemplate?.disclaimer || "",
          default_sender_email: selectedTemplate?.default_sender_email || "",
          body: selectedTemplate?.body || "",
          signature_option: selectedTemplate?.signature_option || "",
          signature:
            selectedTemplate?.signature_option === "custom_signature"
              ? selectedTemplate?.signature
              : "",
        };

        // Dispatch the updated email template to the store
        dispatch(
          setNewEmailTemplateLocal({ emailTemplate: updatedEmailTemplate }),
        );
      }
    } else {
      dispatch(
        setNewEmailTemplateLocal({
          emailTemplate: {
            ...newEmailTemplateLocal.emailTemplate,
            template_id: "",
            // template_name: "",
            // subject: "",
            // disclaimer: "",
            default_sender_email: "",
            body: "",
            signature: "",
            signature_option: "",
          },
        }),
      );
    }
  }, [
    newEmailTemplateLocal?.emailTemplate?.event,
    allEmailTemplates,
    dispatch,
  ]);

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        const { category, ...rest } = newEmailTemplateLocal?.emailTemplate;
        const payload = {
          ...rest,
          // Save subject as plain text so placeholder tags bind correctly.
          subject: getEditorPlainText(rest.subject || ""),
          signature:
            rest.signature_option === "custom_signature" ? rest.signature : "",
        };
        if (selectTemplate || payload?.template_id) {
          dispatch(updateEmailTemplateAction(payload));
        } else {
          dispatch(addEmailTemplateAction(payload));
        }
      } else {
      }
      setIsActionCalled(false);
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    dispatch(setAddEmailTemplateSuccessAction(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setSelectedRow(null);
    setTimeout(() => {
      dispatch(resetNewEmailTemplateLocal());
    }, 300);
  };

  useEffect(() => {
    if (isAddEmailTemplateSuccess) {
      hideHandler();
    }
  }, [isAddEmailTemplateSuccess]);

  const handlePosition = (id: string) => {
    if (id) {
      setFocusedField({
        id,
        cursorPosition: getCaretCharacterOffsetWithin(id) || 0,
      });
    }
  };

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  const handleClear = () => {
    if (selectTemplate?.template_id) {
      setTimeout(() => {
        dispatch(
          setNewEmailTemplateLocal({
            emailTemplate: selectTemplate,
          }),
        );
      }, 300);
      dispatch(
        setNewEmailTemplateLocal({
          emailTemplate: selectTemplate,
        }),
      );
      resetAllValidator();
    } else {
      dispatch(setNewEmailTemplateLocal(initialEmailTemplateLocalState));
      setTimeout(() => {
        dispatch(resetNewEmailTemplateLocal());
      }, 300);
      resetAllValidator();
    }
    setIsReset(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const updateField = emailTemplateFields.map((field) => {
     if(field?.id === "lead_stage"){
      return {
        ...field,
        options: leadStageWithPlaceholders.map((item: any) => ({
          label: item.description,
          id: item.stage,
        })),
      };
    } else if(field?.id ==="default_sender_email"){
      return {
        ...field,
        options: senderEmailOptions.filter((option) => option),
      }
    }
    return field;
  });

  // 🔹 Compute placeholders dynamically based on selected category + event
  const placeholderTagValue = updateField
    ?.filter((field) => field.id === "lead_stage")
    .map((field) => {
      if (field.id === "lead_stage") {
        const selectedLeadStage = leadStageWithPlaceholders.find(
          (item: any) => item.stage === newEmailTemplateLocal?.emailTemplate?.lead_stage,
        );
        return selectedLeadStage ? selectedLeadStage.placeholders : [];
      }
      return [];
    })
    .flat();  


  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={"lg"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={SAVE_ICON}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={RESET_ICON}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={CLOSE_ICON}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Notification />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    {updateField
                      ?.filter(
                        (field) =>
                          !(
                            (!newEmailTemplateLocal?.emailTemplate?.category ||
                              newEmailTemplateLocal?.emailTemplate?.category ===
                                "client") &&
                            field.id === "disclaimer"
                          ),
                      )
                      .map((field, i) => {
                        if (
                          field.id === "signature" &&
                          newEmailTemplateLocal?.emailTemplate
                            ?.signature_option !== "custom_signature"
                        ) {
                          return null; // Do not render the signature field if custom_signature is selected
                        } 
                        return (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={
                                field?.type === "editor" ||
                                field?.type === "radio"
                                  ? 12
                                  : 6
                              }
                              key={i}
                              sx={{ padding: "0px 4px" }}
                            >
                              <Grid container spacing={2}>
                                <FormField
                                  key={field.id}
                                  onPaste={(e) =>
                                    field?.id === "subject"
                                      ? ""
                                      : e.preventDefault()
                                  }
                                  onKeyDown={(event: any) => {
                                    setIsReset(false);
                                    console.log(
                                      "event log-",
                                      event,
                                      event.target.value + event.key,
                                    );
                                    if (
                                      event.keyCode === 8 ||
                                      event.keyCode === 9 ||
                                      event.keyCode === 37 ||
                                      event.keyCode === 38 ||
                                      event.keyCode === 39 ||
                                      event.keyCode === 40 ||
                                      event.keyCode === 18 ||
                                      event.keyCode === 17 ||
                                      event.ctrlKey
                                    )
                                      return event;
                                    if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(event.key)
                                    ) {
                                      event.preventDefault();
                                    } else if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(
                                        event.target.value + event.key,
                                      )
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                  {...{
                                    ...field,
                                    ...(field.id === "subject" && {
                                      editorConfig: {
                                        hideFontControls: true,
                                        showPreview: false,
                                        showFormattingToggle: false,
                                        showEditToggle: false,
                                        disableEnter: true,
                                      },
                                    }),
                                    placeholderValue: placeholderTagValue,
                                    checked:
                                      field?.type ==='checkbox'?
                                      newEmailTemplateLocal?.emailTemplate?.[field.id] || false : undefined
                                    ,
                                    value: field.type !== "checkbox" && newEmailTemplateLocal?.emailTemplate
                                      ? newEmailTemplateLocal?.emailTemplate[
                                          field?.id
                                        ]
                                      : "",
                                    ...{
                                      variant: "outlined", // Adding this variant prop
                                      onChange: onChangeAction,
                                      onBlur: onBlurAction,

                                      onMouseUp: () => handlePosition(field.id),
                                      onKeyUp: () => handlePosition(field.id),

                                      InputProps: {
                                        ...(field?.inputProps &&
                                          field?.inputProps),
                                        ...(field?.autocomplete && {
                                          autocomplete: field?.autocomplete,
                                        }),

                                        sx:
                                          field?.type === "text" ||
                                          field?.type === "password"
                                            ? { height: "36px" }
                                            : {
                                                padding: "10px 4px",
                                                height: "36px",
                                              },
                                      },

                                      // error:
                                      //   field?.id === "signature" &&
                                      //   newEmailTemplateLocal?.emailTemplate ===
                                      //     "custom_signature" &&
                                      //   isCustomeSignature
                                      //     ? true
                                      //     : error && error[field?.id],
                                      error: error && error[field?.id],
                                      helperText: error && error[field?.id],
                                      selectedValues:
                                        newEmailTemplateLocal?.emailTemplate[
                                          field?.id
                                        ],
                                      // helperText:
                                      //   emailSettingError && emailSettingError[field?.id],
                                    },
                                    onFocus: () => handlePosition(field.id),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </>
                        );
                      })}
                  </Grid>
                </Grid>
                <br />
                <Grid item xs={12} md={12}>
                  {newEmailTemplateLocal?.emailTemplate?.lead_stage && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                      Only the provided tags are allowed. Please use them while
                      creating the template — don’t use any other tags. Always
                      write tag names inside{" "}
                      <strong>double curly braces</strong>, for example:{" "}
                      <code>
                        {"{{username}}"}, {"{{CompanyName}}"}
                      </code>
                      .
                    </Alert>
                  )}
                </Grid>
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};
export default ManageEmailTemplate;
